<template>
    <div class="timline-box">
        <el-timeline>
            <el-timeline-item v-for="(value, key) in list" :key="key" :timestamp="value.timestamp" placement="top"
                :icon="value.icon" :type="value.type" :color="value.color" size="large">
                <el-card>
                    <h4>{{ value.title }}</h4>
                    <p class="timeline-content">{{ value.content }}</p>
                    <p class="edit-name">许圣斌 提交</p>
                </el-card>
            </el-timeline-item>

        </el-timeline>
    </div>
</template>

<script>

export default {
    props: {
        id: Number
    },
    data() {
        return {
            list: [{
                title: '维护设备',
                content: '设备进水，无法正常使用，需要更换设备',
                timestamp: '2025/04/12 20:46',
                type: 'warning',
                icon: 'iconfont icon-dianpushezhi1'
            }, {
                title: '铺设设备',
                content: '设备网络不稳定，联通信号为2格',
                timestamp: '2024/04/08 20:46',
                color: 'red',
                icon: "iconfont icon-fangzhidian"
            }, {
                title: "达成合作",
                content: '暂时决定铺设12对蜡烛，需要在观音发挥前放置',
                timestamp: '2024/04/06 20:46',
                type: 'success',
                icon: "iconfont icon-woshou"
            }, {
                title: '接触主持',
                content: '师父意向不明，需要接触几次',
                type: 'info',
                icon: 'iconfont icon-jiechulishi',
                timestamp: '2023/04/03 20:46'
            }]
        };
    },
    computed: {},
    mounted() {

    },
    methods: {

    }
};
</script>

<style lang="scss" scoped>
.timeline-content {
    width: 100%;
    margin-bottom: 20px;
    font-size: 14px;
    ;
    margin-top: 5px;
}

.edit-name {
    font-size: 12px;
    color: #999;
    width: 100%;
    text-align: right;
}
</style>